import {FC, PropsWithChildren} from 'react'

import {
  HEADER_HEIGHT_DESKTOP,
  HEADER_HEIGHT_MOBILE,
  HEADER_MAX_WIDTH,
  HEADER_PADDING_DESKTOP,
  HEADER_PADDING_MOBILE,
} from '@/theme/sizing'
import {theme} from '@/theme/theme'
import {TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

import Overlay from '../common/overlay/Overlay'

type HeaderProps = {
  isOverlayVisible?: boolean
  onOverlayClose?: () => void
}

export const Header: FC<PropsWithChildren<HeaderProps>> = ({
  isOverlayVisible,
  onOverlayClose,
  children,
}) => {
  return (
    <>
      <header id="header" className="header" data-test="header">
        <div className="overlay">
          <Overlay visible={isOverlayVisible} close={onOverlayClose} />
        </div>
        <div className="wrapper">{children}</div>
      </header>

      <style jsx>{`
        .header {
          position: sticky;
          width: 100%;
          height: ${HEADER_HEIGHT_DESKTOP};
          left: 0;
          right: 0;
          top: 0;
          z-index: 3;
          display: flex;
          align-items: flex-end;
          justify-content: center;
          padding: 0 ${HEADER_PADDING_DESKTOP};
        }
        .wrapper {
          position: relative;
          width: 100%;
          max-width: ${HEADER_MAX_WIDTH};
          padding: ${theme.spacing[3]};
          background-color: ${theme.palette.tertiary.main};
          border-radius: 20px;
          z-index: 2;
        }
        .overlay {
          display: none;
        }
        @media ${TABLET_SCREENSIZE} {
          .header {
            position: fixed;
            top: unset;
            bottom: 0;
            align-items: flex-start;
            height: ${HEADER_HEIGHT_MOBILE};
            padding: 0 ${HEADER_PADDING_MOBILE};
            padding-bottom: calc(${HEADER_PADDING_MOBILE} + env(safe-area-inset-bottom));
          }
          .wrapper {
            padding: 0;
            box-shadow: inset 0 0 0 1px ${theme.palette.gray[600]};
          }
          .overlay {
            display: block;
          }
        }
      `}</style>
    </>
  )
}
